import moment from "moment";
import "moment-timezone";
import { IsoToDateWithoutTime } from "../../CommonFunction/IsoDateTime";

export const ChangeDateValues = (value) => {
  const obj = { ...value };

  // helper to test for an ISO string
  const isISO = (s) =>
    typeof s === "string" &&
    moment(s, moment.ISO_8601, true).isValid();

  if (isISO(obj?.createdAt)) {
    obj.createdAt = moment(obj.createdAt)
      .tz("Asia/Kolkata")
      .format("DD/MM/YYYY hh:mm:ss A");
  }

  if (isISO(obj?.updatedAt)) {
    obj.updatedAt = moment(obj.updatedAt)
      .tz("Asia/Kolkata")
      .format("DD/MM/YYYY hh:mm:ss A");
  }

  if (isISO(obj?.Date)) {
    // your helper will strip the time portion
    obj.Date = IsoToDateWithoutTime(obj.Date);
  }

  if (isISO(obj?.Expiry_Time)) {
    obj.Expiry_Time = moment(obj.Expiry_Time)
      .tz("Asia/Kolkata")
      .format("DD/MM/YYYY hh:mm:ss A");
  }

  Object.keys(obj).forEach((key) => {
    if (
      typeof obj[key] === "object" &&
      key !== "LR_Invoice_Data" &&
      key !== "Vehicle_No_Data" &&
      key !== "Driver_Name_Data" &&
      obj[key] !== null
    ) {
      delete obj[key];
    }
  });

  delete obj.__typename;
  delete obj.is_Audit;

  return obj;
};

// For your table of values
export const ConvertDateValues = (data) => {
  if (data && !Array.isArray(data)) {
    throw new TypeError("Expected an array");
  }
  return data?.map(ChangeDateValues);
};
